module.exports = __webpack_public_path__ + "img/preview.031251c7.png";